import React from 'react';
import { createPortal } from 'react-dom';
import styles from '../static/styles/MessagePopup.module.css';

const MessagePopup = ({ isOpen, message, onClose, actionLabel, onAction }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className={styles.popupOverlay} onClick={onClose}>
      <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
        <p className={styles.message}>{message}</p>
        {onAction ? (
          <div className={styles.popupButtons}>
            <button className={styles.cancelButton} onClick={onClose}>
              Close
            </button>
            <button className={styles.submitButton} onClick={onAction}>
              {actionLabel || 'Continue'}
            </button>
          </div>
        ) : (
          <button className={styles.closeButton} onClick={onClose}>
            Close
          </button>
        )}
      </div>
    </div>,
    document.body
  );
};

export default MessagePopup;